'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2;

var _mobx = require('mobx');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DefendantStore = (_class = function () {
  function DefendantStore(caseStore, transport) {
    _classCallCheck(this, DefendantStore);

    _initDefineProp(this, 'insurerOptions', _descriptor, this);

    _initDefineProp(this, 'queryResults', _descriptor2, this);

    this.caseStore = caseStore;
    this.transport = transport;
  }

  _createClass(DefendantStore, [{
    key: 'create',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var caseId = _ref2.caseId,
            defendantData = _ref2.defendantData;
        var defendant;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                defendantData.case = caseId;

                _context.next = 3;
                return this.transport.post('/defendants/', { data: defendantData });

              case 3:
                defendant = _context.sent;


                this.caseStore.setDefendant({ caseId: caseId, defendant: defendant });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _ref.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
        var caseId = _ref4.caseId,
            defendantData = _ref4.defendantData;
        var defendant;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                defendantData.case = caseId;

                _context2.next = 3;
                return this.transport.put('/defendants/:defendantId/', {
                  data: defendantData,
                  urlParams: { defendantId: defendantData.id }
                });

              case 3:
                defendant = _context2.sent;


                this.caseStore.setDefendant({ caseId: caseId, defendant: defendant });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x2) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'upsert',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_case, defendantData) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!defendantData.id) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return this.update({ caseId: _case.id, defendantData: defendantData });

              case 3:
                _context3.next = 9;
                break;

              case 5:
                if (!defendantData.name) {
                  _context3.next = 9;
                  break;
                }

                defendantData.id = _uuid2.default.v4();
                _context3.next = 9;
                return this.create({ caseId: _case.id, defendantData: defendantData });

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsert(_x3, _x4) {
        return _ref5.apply(this, arguments);
      }

      return upsert;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DefendantStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'insurerOptions', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'queryResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'create', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'create'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'upsert', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'upsert'), _class.prototype)), _class);
var _default = DefendantStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DefendantStore, 'DefendantStore', '/app/src/stores/DefendantStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/DefendantStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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